export enum SubSectionType {
  IRIS = 'IRIS',
  ANNUAL_CHANGE = 'ANNUAL_CHANGE',
  RESERVES = 'RESERVES',
  BOOK_OF_BUSINESS = 'BOOK_OF_BUSINESS',
  REINSURERS = 'REINSURERS',
  DIRECT_LOSSES = 'DIRECT_LOSSES',
  SPECIAL_BONDS = 'SPECIAL_BONDS',
  MLR_REBATES = 'MLR_REBATES',
  LINE_OF_BUSINESS = 'LINE_OF_BUSINESS',
  MLR_SHCE = 'MLR_SHCE',
  OR_BY_LOB = 'OR_BY_LOB',
  POLICY_COMPARISON = 'POLICY_COMPARISON',
  CURRENT_YEAR_EXPENSES = 'CURRENT_YEAR_EXPENSES',
  QTR_ROLLING = 'QTR_ROLLING',
  QTR_COMPARABLE = 'QTR_COMPARABLE',
  QTR_REINSURERS = 'QTR_REINSURERS',
  QTR_BOOK_OF_BUSINESS = 'QTR_BOOK_OF_BUSINESS',
  QTR_DIR_PREM = 'QTR_DIR_PREM'
}
